(function () {
'use strict';
angular.module('hyresgastApp').controller('NewFreeAgreementModalCtrl', NewFreeAgreementModalCtrl);

function NewFreeAgreementModalCtrl($uibModalInstance, $scope,
  agreement, users, invites,
  User,
  FreeAgreementTypes, Parties) {
  var vm = this;

  vm.FreeAgreementTypes = FreeAgreementTypes;

  vm.userContainer = {
    hgfSide: [],
    faSide: [],
  };

  if (users) {
    let hgfSide = users.filter(u => u.party === Parties.HGF);
    hgfSide.forEach(p => p.isChief = p.roleObj.isChief);
    let faSide = users.filter(u => u.party !== Parties.HGF); //we want delegates too
    faSide.forEach(p => p.isChief = p.roleObj.isChief);

    vm.userContainer = {
      hgfSide,
      faSide,
      chiefNegotiatorHGF: hgfSide.find(p => p.isChief),
      chiefNegotiatorExternal: faSide.find(p => p.isChief),
      invites,
    };
    vm.skipOrganizationSet = true;
  }

  $scope.$watch('vm.userContainer.faSide', function (newVal) {
    let id = newVal.find(p => p.isChief).userId;
    User.queryOrganization({ id }).$promise.then(response => {
      vm.userOrganizations = response;

      if (vm.skipOrganizationSet) {
        vm.skipOrganizationSet = false;
        if (agreement && agreement.conditionTags.organization) {
          vm.selectedOrganization = agreement.conditionTags.organization;
        } else {
          vm.selectedOrganization = vm.userOrganizations[0];
        }
      } else {
        vm.selectedOrganization = vm.userOrganizations[0];
      }
    });
  });

  vm.ok = () => {
    $uibModalInstance.close({
      userContainer: vm.userContainer,
      type: vm.type,
      message: vm.message,
      organization: vm.selectedOrganization,
    });
  };
  vm.cancel = () => { $uibModalInstance.close({ cancel: true }) };
}
})();